//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { SliceNames } from '@redux/SliceNames';
import { createSlice } from '@reduxjs/toolkit';
import { IPinterestPostDetailsModalState } from '@pinterest/redux/post-details/modals/pinterestPostDetailsModalsModel';

const initialState: IPinterestPostDetailsModalState = {
  isVideoErrorModalOpen: false,
  isMixedMediaErrorModalOpen: false,
};

const { actions, reducer } = createSlice({
  name: SliceNames.PinterestPostDetailsModals,
  initialState,
  reducers: {
    toggleVideoErrorModal(state) {
      state.isVideoErrorModalOpen = !state.isVideoErrorModalOpen;
    },
    toggleMixedMediaErrorModal(state) {
      state.isMixedMediaErrorModalOpen = !state.isMixedMediaErrorModalOpen;
    },
  },
});

export const { toggleVideoErrorModal, toggleMixedMediaErrorModal } = actions;

export default reducer;
